import { useCallback, useState } from "react";

import { archivedHiddenNote, readShowArchived, writeShowArchived } from "../lib/superadminArchived";

/** Casilla «Mostrar archivados», recordada por pantalla en este navegador.
 * Arranca apagada: los archivados se ocultan por default. */
export function useShowArchived(storageKey: string): [boolean, (value: boolean) => void] {
  const [showArchived, setShowArchived] = useState(() => readShowArchived(storageKey));
  const update = useCallback(
    (value: boolean) => {
      setShowArchived(value);
      writeShowArchived(storageKey, value);
    },
    [storageKey],
  );
  return [showArchived, update];
}

interface Props {
  /** Torneos que se están mostrando. */
  shownCount: number;
  archivedCount: number;
  hiddenCount: number;
  showArchived: boolean;
  onToggle: (value: boolean) => void;
  /** Bloquea la casilla (p. ej. mientras se elimina un torneo). */
  disabled?: boolean;
}

/**
 * Encabezado de las listas de torneos del superadmin (Gobierno y Fees):
 * «Torneos (N)», cuántos archivados quedaron ocultos y la casilla para
 * mostrarlos. La casilla solo aparece si hay archivados.
 */
export default function SuperadminArchivedHeader({
  shownCount,
  archivedCount,
  hiddenCount,
  showArchived,
  onToggle,
  disabled = false,
}: Props) {
  return (
    <div className="gov-list-header">
      <div>
        <h2 className="card__title">Torneos ({shownCount})</h2>
        {hiddenCount > 0 ? (
          <p className="muted gov-archived-note" data-no-toast>
            {archivedHiddenNote(hiddenCount)}
          </p>
        ) : null}
      </div>
      {archivedCount > 0 ? (
        <label className="form__checkbox gov-tombstone-toggle">
          <input
            type="checkbox"
            checked={showArchived}
            onChange={(event) => onToggle(event.target.checked)}
            disabled={disabled}
          />
          <span>Mostrar archivados ({archivedCount})</span>
        </label>
      ) : null}
    </div>
  );
}
